import { Box, useTheme } from '@mui/material';
import useWidth from '../../../../components/Hooks/useWidth';
import Highlights from '../../../../modules/highlights/Highlights';
import RachelInput from '../../../../modules/rachel/components/RachelInput/RachelInput';
import { useIsRachelFooterInputVisible } from '../../../../modules/rachel/hooks/useIsRachelFooterInputVisible';
import { useRachelDockedWidth } from '../../../../modules/rachel/hooks/useRachelDockedWidth';
import {
  RACHEL_PANEL_WIDTH,
  getRachelDockedColumnWidth,
} from '../../../../modules/rachel/rachel.layout';
import UserMenuTrigger from '../UserMenu/UserMenuTrigger';

const HomeNavigationBottomBar = () => {
  const isRachelInputVisible = useIsRachelFooterInputVisible();
  const rachelDockedWidth = useRachelDockedWidth() ?? RACHEL_PANEL_WIDTH;
  const { mobileWidth: isMobile } = useWidth();
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
      }}
    >
      {!isMobile && <UserMenuTrigger />}
      <Highlights />
      {isRachelInputVisible && (
        <Box
          style={{ width: getRachelDockedColumnWidth(theme, rachelDockedWidth) }}
          sx={(theme) => ({
            position: 'relative',
            zIndex: theme.zIndex.drawer,
            maxWidth: '100%',
            transform: 'translateY(1px)',
          })}
        >
          <RachelInput />
        </Box>
      )}
    </Box>
  );
};

export default HomeNavigationBottomBar;
